import { render, staticRenderFns } from "./Hot.vue?vue&type=template&id=60b53660&scoped=true&"
import script from "./Hot.vue?vue&type=script&lang=js&"
export * from "./Hot.vue?vue&type=script&lang=js&"
import style0 from "./Hot.vue?vue&type=style&index=0&id=60b53660&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b53660",
  null
  
)

export default component.exports